export class EmployeeNotFoundError extends Error {
  constructor(m: string) {
    super(m);
    Object.setPrototypeOf(this, EmployeeNotFoundError.prototype);
  }
}
